import { Navigate } from "react-router-dom";
import { ROUTE_DASHBOARD } from "../constants/route";
import { getItem } from "../helpers/cookies";
import { AUTH_TOKEN } from "../constants";
import { isTokenExpired } from "../helpers/general";

const RedirectLoggedIn = ({ children }) => {
  const token = getItem(AUTH_TOKEN);

  // Redirect logged-in users to the dashboard
  if (token && !isTokenExpired(token)) {
    return <Navigate to={ROUTE_DASHBOARD} />;
  }
  // Render the public route if the user is not logged in
  return <>{children}</>;
};

export default RedirectLoggedIn;
